import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './GuidanceQuestions-hashed.scss';
import templateStr from 'text!./GuidanceQuestions.html';
import _ from 'lodash';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            questions: '=',
            isPanelValid: '&',
            continueToNextPanel: '&',
            isActive: '&',
            displayInfo: '&',
            transitionFn: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', 'guidance.DynamicContent', function ($scope, dynamicContent) {
            $scope.toggleState = function (question) {
                question.answer.value = !question.answer.value;
            };

            $scope.getIcon = dynamicContent.getQuestionIcon;

            $scope.getState = function (question) {
                return question.answer.value ? 'completed' : 'selectable';
            };

            $scope.transformQuestions = _.memoize(transformQuestions);

            function transformQuestions(questionList) {
                return questionList.map(function (question) {
                    return {
                        model: question.answer,
                        icon: $scope.getIcon(question.code.value),
                        selectText: question.text.value,
                        helpText: question.helpText.value
                    };
                });
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/Questions/GuidanceQuestions.js
// module id = 961
// module chunks = 0